module.exports = __webpack_public_path__ + "img/bg-document-1.74b4adc4.png";